/* Modified by LB 2026-08-11 - Jersey player URL, no-reload size sync and orphan personalisation protection - start */
(function () {
  'use strict';

  var namespace = window.BCWFCJerseyPersonalisation = window.BCWFCJerseyPersonalisation || {};
  if (namespace.initialised) return;
  namespace.initialised = true;

  var PAGE = window.BCWFCJerseyPersonalisationPage || {};

  var CONFIG = {
    playerParameter: 'player',
    playerWaitLimit: 20000,
    playerRetryDelay: 180,
    variantWaitLimit: 5000,
    variantRetryDelay: 60,
    cartCheckDelay: 650,
    cartConfirmationDelay: 800,
    cartRequestTimeout: 12000,
    personaliserRootSelector: '.product-personalizer',
    personaliserButtonSelector: '.pplr-c-button',
    sizeOptionNames: ['size', 'taglia', 'talla', 'taille', 'grosse', 'groesse', 'größe'],
    playerModeLabels: [
      'player',
      'player printing',
      'official player',
      'choose a player',
      'select a player',
      'player name and number',
      'player name number'
    ],
    personalisationTitles: ['item personalization', 'item personalisation'],
    personalisationHandles: ['item-personalization', 'item-personalisation']
  };

  var state = {
    playerStartedAt: 0,
    playerApplied: false,
    playerTimer: null,
    playerObserver: null,
    sizeChangeSequence: 0,
    lastSizeValue: '',
    cartCheckTimer: null,
    cartCheckRunning: false,
    cartRefreshRunning: false,
    cartObserver: null,
    cartObservedNode: null,
    lastCartMutationAt: 0
  };

  function normalise(value) {
    var text = String(value == null ? '' : value);

    try {
      text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    } catch (error) {
      /* Older browsers can continue without Unicode normalisation. */
    }

    return text
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[’'`]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .replace(/\s+/g, ' ');
  }

  function compact(value) {
    return normalise(value).replace(/\s+/g, '');
  }

  function safeJsonParse(value, fallback) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  }

  function escapeSelector(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(String(value));
    }

    return String(value).replace(/([ #;&,.+*~':"!^$[\]()=>|/@])/g, '\\$1');
  }

  function isElementVisible(element) {
    if (!element || element.nodeType !== 1) return false;
    if (element.hidden || element.getAttribute('aria-hidden') === 'true') return false;

    var style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;

    return element.getClientRects().length > 0;
  }

  function dispatchControlEvents(control) {
    if (!control) return;
    control.dispatchEvent(new Event('input', { bubbles: true }));
    control.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function getMainContent() {
    return document.getElementById('MainContent') || document;
  }

  function findPersonaliserRoot() {
    var roots = Array.prototype.slice.call(document.querySelectorAll(CONFIG.personaliserRootSelector));
    if (!roots.length) return null;

    var matchingRoot = roots.find(function (root) {
      var dataId = String(root.getAttribute('data-id') || root.dataset.id || '');
      return PAGE.productId && dataId === String(PAGE.productId);
    });

    if (matchingRoot) return matchingRoot;

    return roots.find(function (root) {
      return getMainContent().contains(root);
    }) || null;
  }

  function productLooksLikeJersey() {
    if (!PAGE.isProduct || !PAGE.productId) return false;

    var templateSuffix = normalise(PAGE.templateSuffix);
    if (templateSuffix === 'kit shirts' || templateSuffix === 'kit shirt' || templateSuffix.indexOf('jersey') !== -1) {
      return true;
    }

    var productText = normalise([
      PAGE.productHandle,
      PAGE.productTitle,
      PAGE.productType
    ].join(' '));

    if (productText.indexOf('jersey') !== -1) return true;

    return /\b(home|away|third|goalkeeper|goal keeper|gk|football|playing)\b.*\bshirt\b/.test(productText) ||
      /\bshirt\b.*\b(home|away|third|goalkeeper|goal keeper|gk|26 27|2026 27)\b/.test(productText);
  }

  function isRelevantJerseyPage() {
    if (!productLooksLikeJersey()) return false;

    var root = findPersonaliserRoot();
    if (!root) {
      return normalise(PAGE.templateSuffix) === 'kit shirts';
    }

    var dataId = String(root.getAttribute('data-id') || root.dataset.id || '');
    return !dataId || dataId === String(PAGE.productId);
  }

  function getRequestedPlayer() {
    var url = new URL(window.location.href);
    var player = url.searchParams.get(CONFIG.playerParameter);
    return player ? player.trim() : '';
  }

  function collectElementText(element) {
    if (!element) return '';

    return [
      element.textContent,
      element.value,
      element.getAttribute && element.getAttribute('aria-label'),
      element.getAttribute && element.getAttribute('data-value'),
      element.getAttribute && element.getAttribute('data-label'),
      element.getAttribute && element.getAttribute('data-name'),
      element.getAttribute && element.getAttribute('title'),
      element.getAttribute && element.getAttribute('name'),
      element.getAttribute && element.getAttribute('id'),
      element.getAttribute && element.getAttribute('class')
    ].filter(Boolean).join(' ');
  }

  function getAssociatedLabels(control) {
    var labels = [];

    if (control && control.id) {
      labels = labels.concat(Array.prototype.slice.call(
        document.querySelectorAll('label[for="' + escapeSelector(control.id) + '"]')
      ));
    }

    var closestLabel = control && control.closest ? control.closest('label') : null;
    if (closestLabel && labels.indexOf(closestLabel) === -1) labels.push(closestLabel);

    return labels;
  }

  function getControlOptionText(control) {
    var parts = [collectElementText(control)];

    getAssociatedLabels(control).forEach(function (label) {
      parts.push(label.textContent || '');
      parts.push(label.getAttribute('data-value') || '');
      parts.push(label.getAttribute('aria-label') || '');
    });

    return normalise(parts.join(' '));
  }

  function isControlUsable(control) {
    if (!control || control.disabled) return false;
    if (isElementVisible(control)) return true;

    return getAssociatedLabels(control).some(function (label) {
      return isElementVisible(label);
    });
  }

  function collectControlContext(control) {
    var parts = [getControlOptionText(control)];
    var parent = control && control.parentElement;
    var depth = 0;

    while (parent && depth < 4) {
      if (parent.classList && parent.classList.contains('product-personalizer')) break;

      var parentText = collectElementText(parent);
      if (parentText.length <= 500) parts.push(parentText);

      parent = parent.parentElement;
      depth += 1;
    }

    return normalise(parts.join(' '));
  }

  function looksLikePlayerOption(value) {
    var text = normalise(value);
    return Boolean(text && /[a-z]{2,}/.test(text) && /\b\d{1,2}\b/.test(text));
  }

  function selectLooksLikePlayerList(select) {
    if (!select || select.tagName !== 'SELECT') return false;

    var likelyPlayers = Array.prototype.slice.call(select.options || []).filter(function (option) {
      return looksLikePlayerOption(option.textContent || option.value);
    });

    return likelyPlayers.length >= 2;
  }

  function getPlayerNumber(value) {
    var text = normalise(value);
    var matches = text.match(/\b\d{1,2}\b/g);
    return matches && matches.length ? matches[matches.length - 1] : '';
  }

  function scorePlayerMatch(candidate, requestedPlayer) {
    var candidateNormalised = normalise(candidate);
    var requestedNormalised = normalise(requestedPlayer);

    if (!candidateNormalised || !requestedNormalised) return -1;
    if (/^(select|choose|please select|none|no player|custom|custom name)$/.test(candidateNormalised)) return -1;

    var requestedNumber = getPlayerNumber(requestedNormalised);
    var candidateNumber = getPlayerNumber(candidateNormalised);

    if (requestedNumber && candidateNumber && requestedNumber !== candidateNumber) return -1;

    var candidateCompact = compact(candidateNormalised);
    var requestedCompact = compact(requestedNormalised);

    if (candidateNormalised === requestedNormalised) return 120;
    if (candidateCompact === requestedCompact) return 115;

    var cleanedCandidate = candidateNormalised
      .replace(/^(player|official player|player printing|choose player|select player)\s+/, '')
      .trim();

    if (cleanedCandidate === requestedNormalised) return 110;
    if (compact(cleanedCandidate) === requestedCompact) return 105;

    var requestedTokens = requestedNormalised.split(' ').filter(Boolean);
    var candidateTokens = candidateNormalised.split(' ').filter(Boolean);
    var allTokensPresent = requestedTokens.every(function (token) {
      return candidateTokens.indexOf(token) !== -1;
    });

    if (allTokensPresent) return 95 + Math.min(requestedTokens.length, 5);
    if (candidateNormalised.indexOf(requestedNormalised) !== -1) return 88;

    if (!requestedNumber) {
      var candidateWithoutNumber = candidateNormalised.replace(/\s+\d{1,2}\b.*$/, '').trim();
      if (candidateWithoutNumber === requestedNormalised) return 80;
      if (candidateWithoutNumber.indexOf(requestedNormalised) !== -1) return 72;
    }

    return -1;
  }

  function getPersonaliserSearchScopes() {
    var root = findPersonaliserRoot();
    var scopes = [];

    if (root) scopes.push(root);

    var dialogs = document.querySelectorAll(
      '[role="dialog"], .pplr-wrapper, .pplr-modal, .pplr-popup, .personalizer-popup, .product-personalizer-popup'
    );

    Array.prototype.forEach.call(dialogs, function (dialog) {
      if (isElementVisible(dialog)) scopes.push(dialog);
    });

    if (!scopes.length) scopes.push(getMainContent());

    return scopes.filter(function (scope, index, list) {
      return list.indexOf(scope) === index;
    });
  }

  function findVisiblePlayerControl() {
    var best = null;

    getPersonaliserSearchScopes().forEach(function (scope) {
      Array.prototype.forEach.call(scope.querySelectorAll('select'), function (select) {
        if (best || !isElementVisible(select)) return;

        var context = collectControlContext(select);
        if (context.indexOf('player') !== -1 || selectLooksLikePlayerList(select)) best = select;
      });

      Array.prototype.forEach.call(scope.querySelectorAll('input[type="radio"], input[type="checkbox"]'), function (input) {
        if (best || !isControlUsable(input)) return;

        var context = collectControlContext(input);
        var optionText = getControlOptionText(input);
        if (context.indexOf('player') !== -1 && looksLikePlayerOption(optionText)) best = input;
      });
    });

    return best;
  }

  function findPersonaliseButton() {
    var root = findPersonaliserRoot();
    var scope = root || getMainContent();
    var directButton = scope.querySelector(CONFIG.personaliserButtonSelector);

    if (directButton && isElementVisible(directButton) && !directButton.disabled) return directButton;

    var patterns = [
      'personalise',
      'personalize',
      'customise',
      'customize',
      'make it yours',
      'add name and number',
      'add name number'
    ];

    return Array.prototype.find.call(scope.querySelectorAll('button, a, [role="button"]'), function (control) {
      if (!isElementVisible(control) || control.disabled) return false;
      var text = normalise(collectElementText(control));
      return patterns.some(function (pattern) { return text.indexOf(pattern) !== -1; });
    }) || null;
  }

  function ensurePersonaliserOpen() {
    if (findVisiblePlayerControl()) return true;

    var button = findPersonaliseButton();
    if (!button || button.dataset.bcwfcAutoOpened === 'true') return false;

    button.dataset.bcwfcAutoOpened = 'true';
    button.click();
    return false;
  }

  function findPlayerModeControl() {
    var candidates = [];

    getPersonaliserSearchScopes().forEach(function (scope) {
      var controls = scope.querySelectorAll(
        'select, option, input[type="radio"], input[type="checkbox"], label, button, [role="option"], [data-value]'
      );

      Array.prototype.forEach.call(controls, function (control) {
        if (control.tagName !== 'OPTION' && !isElementVisible(control)) return;
        if (control.disabled || control.dataset.bcwfcPlayerModeOpened === 'true') return;

        var text = normalise(collectElementText(control));
        var score = -1;

        CONFIG.playerModeLabels.forEach(function (label, index) {
          if (text === label) score = Math.max(score, 100 - index);
          else if (text.indexOf(label) !== -1 && text.length < 80) score = Math.max(score, 70 - index);
        });

        if (score >= 0 && !looksLikePlayerOption(text)) candidates.push({ control: control, score: score });
      });
    });

    candidates.sort(function (a, b) { return b.score - a.score; });
    return candidates.length ? candidates[0].control : null;
  }

  function activatePlayerMode() {
    if (findVisiblePlayerControl()) return true;

    var control = findPlayerModeControl();
    if (!control) return false;

    control.dataset.bcwfcPlayerModeOpened = 'true';

    if (control.tagName === 'OPTION') {
      var select = control.parentElement;
      if (select && select.tagName === 'SELECT') {
        select.value = control.value;
        dispatchControlEvents(select);
      }
    } else if (control.matches('input[type="radio"], input[type="checkbox"]')) {
      if (!control.checked) control.click();
      else dispatchControlEvents(control);
    } else {
      control.click();
    }

    return false;
  }

  function findBestPlayerChoice(requestedPlayer) {
    var candidates = [];

    getPersonaliserSearchScopes().forEach(function (scope) {
      Array.prototype.forEach.call(scope.querySelectorAll('select'), function (select) {
        if (!isElementVisible(select)) return;

        var context = collectControlContext(select);
        if (context.indexOf('player') === -1 && !selectLooksLikePlayerList(select)) return;

        Array.prototype.forEach.call(select.options || [], function (option) {
          var text = [option.textContent, option.value, option.getAttribute('data-value')].filter(Boolean).join(' ');
          var score = scorePlayerMatch(text, requestedPlayer);
          if (score >= 0) candidates.push({ type: 'select', control: select, option: option, score: score });
        });
      });

      Array.prototype.forEach.call(scope.querySelectorAll('input[type="radio"], input[type="checkbox"]'), function (input) {
        if (!isControlUsable(input)) return;

        var context = collectControlContext(input);
        var optionText = getControlOptionText(input);
        if (context.indexOf('player') === -1 && !looksLikePlayerOption(optionText)) return;

        var score = scorePlayerMatch(optionText, requestedPlayer);
        if (score >= 0) candidates.push({ type: 'input', control: input, score: score });
      });

      var clickable = scope.querySelectorAll(
        'label, button, [role="option"], [data-value], .pplr-image-choice, .pplr-choice, .pplr-radio-label'
      );

      Array.prototype.forEach.call(clickable, function (control) {
        if (!isElementVisible(control) || control.disabled) return;

        var context = collectControlContext(control);
        var optionText = normalise(collectElementText(control));
        if (context.indexOf('player') === -1 && !looksLikePlayerOption(optionText)) return;

        var score = scorePlayerMatch(optionText, requestedPlayer);
        if (score >= 0) candidates.push({ type: 'click', control: control, score: score });
      });
    });

    candidates.sort(function (a, b) {
      if (b.score !== a.score) return b.score - a.score;
      if (a.type === 'select' && b.type !== 'select') return -1;
      if (b.type === 'select' && a.type !== 'select') return 1;
      return 0;
    });

    return candidates.length ? candidates[0] : null;
  }

  function applyPlayerChoice(choice) {
    if (!choice || !choice.control) return false;

    if (choice.type === 'select') {
      choice.control.value = choice.option.value;
      choice.option.selected = true;
      dispatchControlEvents(choice.control);
      return true;
    }

    if (choice.type === 'input') {
      if (!choice.control.checked) choice.control.click();
      else dispatchControlEvents(choice.control);
      return true;
    }

    choice.control.click();
    return true;
  }

  function stopPlayerWatcher() {
    window.clearTimeout(state.playerTimer);
    state.playerTimer = null;

    if (state.playerObserver) {
      state.playerObserver.disconnect();
      state.playerObserver = null;
    }
  }

  function attemptPlayerPreselection() {
    var requestedPlayer = getRequestedPlayer();

    if (!requestedPlayer || !isRelevantJerseyPage() || state.playerApplied) {
      stopPlayerWatcher();
      return;
    }

    if (!state.playerStartedAt) state.playerStartedAt = Date.now();
    if (Date.now() - state.playerStartedAt > CONFIG.playerWaitLimit) {
      stopPlayerWatcher();
      return;
    }

    ensurePersonaliserOpen();
    activatePlayerMode();

    var choice = findBestPlayerChoice(requestedPlayer);
    if (choice && applyPlayerChoice(choice)) {
      state.playerApplied = true;
      stopPlayerWatcher();

      window.dispatchEvent(new CustomEvent('bcwfc:player-preselected', {
        detail: { player: requestedPlayer }
      }));
      return;
    }

    window.clearTimeout(state.playerTimer);
    state.playerTimer = window.setTimeout(attemptPlayerPreselection, CONFIG.playerRetryDelay);
  }

  function startPlayerWatcher() {
    if (!getRequestedPlayer() || !PAGE.isProduct || state.playerApplied) return;

    attemptPlayerPreselection();

    if (!state.playerObserver) {
      state.playerObserver = new MutationObserver(function () {
        if (!state.playerApplied) attemptPlayerPreselection();
      });

      state.playerObserver.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  function getMainVariantPicker() {
    if (!PAGE.productId) return null;

    var selector = 'variant-picker[data-product-id="' + escapeSelector(PAGE.productId) + '"]';
    var pickers = Array.prototype.slice.call(document.querySelectorAll(selector));

    return pickers.find(function (picker) {
      return getMainContent().contains(picker) && !picker.closest('quick-view');
    }) || null;
  }

  function getSelectedVariantId() {
    var productForm = getMainContent().querySelector(
      'product-form[data-product-id="' + escapeSelector(PAGE.productId) + '"]'
    );

    var input = productForm && productForm.querySelector('input[data-product-form-variant][name="id"]');
    var value = input && input.value;

    if (!value) value = new URL(window.location.href).searchParams.get('variant');

    var parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
  }

  function getVariantOptionName(input) {
    if (!input) return '';

    var optionInputs = input.closest('[data-variant-picker-option-inputs]');
    var optionName = input.getAttribute('name') || '';

    if (optionInputs) {
      var firstTextNode = Array.prototype.find.call(optionInputs.childNodes, function (node) {
        return node.nodeType === Node.TEXT_NODE && normalise(node.textContent);
      });

      if (firstTextNode) optionName += ' ' + firstTextNode.textContent;
    }

    var picker = input.closest('variant-picker');
    var labelGroups = picker && picker.querySelectorAll('[data-variant-picker-option-labels]');

    Array.prototype.forEach.call(labelGroups || [], function (labelGroup) {
      var controls = labelGroup.querySelectorAll('label[for]');
      var matchesInput = Array.prototype.some.call(controls, function (label) {
        return label.getAttribute('for') === input.id;
      });

      if (matchesInput) {
        optionName += ' ' + (labelGroup.getAttribute('option-picker-name') || '');
        optionName += ' ' + (labelGroup.textContent || '');
      }
    });

    return normalise(optionName);
  }

  function isSizeVariantInput(input) {
    if (!input || !input.matches('input[type="radio"], select')) return false;

    var picker = input.closest('variant-picker');
    if (!picker || picker !== getMainVariantPicker()) return false;

    var optionName = getVariantOptionName(input);
    var optionTokens = optionName.split(' ');

    return CONFIG.sizeOptionNames.some(function (sizeName) {
      return optionTokens.indexOf(normalise(sizeName)) !== -1;
    });
  }

  function getCurrentSizeValue() {
    var picker = getMainVariantPicker();
    if (!picker) return '';

    var inputs = picker.querySelectorAll('input[type="radio"]:checked, select');
    var sizeInput = Array.prototype.find.call(inputs, isSizeVariantInput);
    return sizeInput ? String(sizeInput.value || '') : '';
  }

  function syncJerseyVariantInUrl(variantId) {
    if (!variantId) return;

    var nextUrl = new URL(window.location.href);
    nextUrl.searchParams.set('variant', String(variantId));

    try {
      window.history.replaceState(window.history.state, '', nextUrl.toString());
    } catch (error) {
      /* Variant selection still works if History API URL sync is unavailable. */
    }
  }

  function waitForSelectedVariant(previousVariantId, sequence, callback) {
    var startedAt = Date.now();

    function check() {
      if (sequence !== state.sizeChangeSequence) return;

      var currentVariantId = getSelectedVariantId();
      if (currentVariantId && currentVariantId !== previousVariantId) {
        callback(currentVariantId);
        return;
      }

      if (Date.now() - startedAt >= CONFIG.variantWaitLimit) return;
      window.setTimeout(check, CONFIG.variantRetryDelay);
    }

    check();
  }

  function handleSizeChange(event) {
    if (!isRelevantJerseyPage()) return;

    var input = event.target;
    if (!isSizeVariantInput(input)) return;

    var newSizeValue = String(input.value || '');
    if (newSizeValue && newSizeValue === state.lastSizeValue) return;
    state.lastSizeValue = newSizeValue;

    var previousVariantId = getSelectedVariantId();
    var sequence = ++state.sizeChangeSequence;

    /*
      Modified by LB 2026-08-11 - do not reload the jersey product page when
      Size changes. Aurora performs the variant change in-place; after its hidden
      variant input updates, we only synchronise ?variant= in the URL. This keeps
      Zepto personalisation, scroll position, locale and the optional ?player=
      parameter intact.
    */
    waitForSelectedVariant(previousVariantId, sequence, function (newVariantId) {
      syncJerseyVariantInUrl(newVariantId);
    });
  }

  function getCartRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    root = root || PAGE.routesRoot || '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function fetchWithTimeout(url, options) {
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timeout = controller ? window.setTimeout(function () { controller.abort(); }, CONFIG.cartRequestTimeout) : null;
    var requestOptions = Object.assign({}, options || {});
    if (controller) requestOptions.signal = controller.signal;

    return window.fetch(url, requestOptions).finally(function () {
      if (timeout) window.clearTimeout(timeout);
    });
  }

  function getItemProperties(item) {
    return item && item.properties && typeof item.properties === 'object' ? item.properties : {};
  }

  function isPersonalisationFeeItem(item) {
    if (!item) return false;

    var title = normalise(item.product_title || item.title || '');
    var handle = normalise(item.handle || '').replace(/\s+/g, '-');
    var productType = normalise(item.product_type || '');

    return productType === 'pplr hidden product' ||
      CONFIG.personalisationTitles.indexOf(title) !== -1 ||
      CONFIG.personalisationHandles.indexOf(handle) !== -1;
  }

  function isJerseyCartItem(item) {
    if (!item || isPersonalisationFeeItem(item)) return false;

    var combined = normalise([
      item.product_title,
      item.title,
      item.handle,
      item.product_type
    ].join(' '));

    if (/\b(t shirt|tee|tshirt)\b/.test(combined) && combined.indexOf('jersey') === -1) return false;
    if (combined.indexOf('jersey') !== -1) return true;

    if (/\b(home|away|third|goalkeeper|goal keeper|gk)\b.*\b(shirt|kit)\b/.test(combined)) return true;
    if (/\b(shirt|kit)\b.*\b(home|away|third|goalkeeper|goal keeper|gk|26 27|2026 27)\b/.test(combined)) return true;

    var propertyKeys = normalise(Object.keys(getItemProperties(item)).join(' '));
    return propertyKeys.indexOf('player') !== -1 &&
      (propertyKeys.indexOf('number') !== -1 || propertyKeys.indexOf('name') !== -1);
  }

  function valueTokens(value) {
    var raw = String(value == null ? '' : value).trim();
    if (!raw) return [];

    var tokens = [raw, normalise(raw), compact(raw)];
    tokens = tokens.concat(raw.match(/\d{5,}/g) || []);

    return tokens.filter(function (token, index, list) {
      return token && list.indexOf(token) === index;
    });
  }

  function cartItemIdentityTokens(item) {
    return [
      item.key,
      item.id,
      item.variant_id,
      item.product_id,
      item.handle,
      item.product_title,
      item.title,
      item.url
    ].reduce(function (tokens, value) {
      return tokens.concat(valueTokens(value));
    }, []);
  }

  function getDirectLinkTokens(item) {
    var properties = getItemProperties(item);
    var tokens = [];
    var hasDirectReference = false;

    Object.keys(properties).forEach(function (key) {
      var normalisedKey = normalise(key);
      var value = properties[key];

      var relationshipKey =
        /(parent|linked|main|original|source|jersey|shirt)/.test(normalisedKey) &&
        /(product|variant|line|item|key|id|handle|url)/.test(normalisedKey);

      var pplrRelationshipKey =
        normalisedKey.indexOf('pplr') !== -1 &&
        /(product|variant|line|item|key|id|handle|url)/.test(normalisedKey);

      if (relationshipKey || pplrRelationshipKey) {
        hasDirectReference = true;
        tokens = tokens.concat(valueTokens(value));
      }
    });

    return {
      hasDirectReference: hasDirectReference,
      tokens: tokens.filter(function (token, index, list) {
        return token && list.indexOf(token) === index;
      })
    };
  }

  function getPersonalisationFingerprint(item) {
    var properties = getItemProperties(item);
    var fingerprint = {};

    Object.keys(properties).forEach(function (key) {
      var normalisedKey = normalise(key);
      var normalisedValue = normalise(properties[key]);

      if (!normalisedValue) return;
      if (/preview|image|file|pdf|svg|price|charge/.test(normalisedKey)) return;

      if (/player|name|number|personal|custom|printing|print/.test(normalisedKey)) {
        fingerprint[normalisedKey] = normalisedValue;
      }
    });

    return fingerprint;
  }

  function fingerprintsMatch(first, second) {
    return Object.keys(first).some(function (key) {
      return second[key] && second[key] === first[key];
    });
  }

  function directLinkMatchesItem(link, item) {
    if (!link.hasDirectReference || !link.tokens.length) return false;

    var identities = cartItemIdentityTokens(item);

    return link.tokens.some(function (linkToken) {
      return identities.some(function (identity) {
        if (!identity || !linkToken) return false;

        return identity === linkToken ||
          (String(linkToken).length >= 6 && String(identity).indexOf(String(linkToken)) !== -1) ||
          (String(identity).length >= 6 && String(linkToken).indexOf(String(identity)) !== -1);
      });
    });
  }

  function isClearlyJerseyPersonalisation(item) {
    var properties = getItemProperties(item);
    var propertyText = normalise(Object.keys(properties).map(function (key) {
      return key + ' ' + properties[key];
    }).join(' '));

    return /\b(player|jersey|shirt|name and number|name number|printing)\b/.test(propertyText);
  }

  function findOrphanPersonalisationItems(cart) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var personalisationItems = items.filter(isPersonalisationFeeItem);
    var baseItems = items.filter(function (item) { return !isPersonalisationFeeItem(item); });
    var jerseyItems = baseItems.filter(isJerseyCartItem);

    return personalisationItems.filter(function (personalisationItem) {
      var directLink = getDirectLinkTokens(personalisationItem);

      if (directLink.hasDirectReference) {
        return !baseItems.some(function (baseItem) {
          return directLinkMatchesItem(directLink, baseItem);
        });
      }

      var personalisationFingerprint = getPersonalisationFingerprint(personalisationItem);
      if (Object.keys(personalisationFingerprint).length) {
        var matchingBaseItem = baseItems.some(function (baseItem) {
          return fingerprintsMatch(personalisationFingerprint, getPersonalisationFingerprint(baseItem));
        });

        if (matchingBaseItem) return false;

        if (isClearlyJerseyPersonalisation(personalisationItem)) {
          var matchingJersey = jerseyItems.some(function (jerseyItem) {
            return fingerprintsMatch(personalisationFingerprint, getPersonalisationFingerprint(jerseyItem));
          });
          return !matchingJersey;
        }
      }

      if (baseItems.length === 0) return true;
      if (jerseyItems.length === 0 && isClearlyJerseyPersonalisation(personalisationItem)) return true;

      return false;
    });
  }

  function getCart() {
    return fetchWithTimeout(getCartRoot() + 'cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to read cart.');
      return response.json();
    });
  }

  function removeCartItems(items) {
    var updates = {};

    items.forEach(function (item) {
      if (item && item.key) updates[item.key] = 0;
    });

    if (!Object.keys(updates).length) return Promise.resolve(null);

    return fetchWithTimeout(getCartRoot() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to remove orphan personalisation item.');
      return response.json();
    });
  }

  function refreshCartDrawer() {
    if (state.cartRefreshRunning) return Promise.resolve();
    state.cartRefreshRunning = true;

    var drawer = document.querySelector('cart-drawer');

    try {
      if (drawer && typeof drawer.update === 'function') drawer.update();
    } catch (error) {
      /* The cart request has succeeded; allow the theme to recover on its next normal update. */
    }

    return new Promise(function (resolve) {
      window.setTimeout(resolve, 300);
    }).finally(function () {
      state.cartRefreshRunning = false;
    });
  }

  function confirmAndRemoveOrphans(firstOrphans) {
    var firstKeys = firstOrphans.map(function (item) { return item.key; }).filter(Boolean);
    if (!firstKeys.length) return Promise.resolve();

    return new Promise(function (resolve) {
      window.setTimeout(resolve, CONFIG.cartConfirmationDelay);
    }).then(getCart).then(function (secondCart) {
      var secondOrphans = findOrphanPersonalisationItems(secondCart).filter(function (item) {
        return firstKeys.indexOf(item.key) !== -1;
      });

      if (!secondOrphans.length) return null;

      return removeCartItems(secondOrphans).then(function () {
        return refreshCartDrawer().then(function () {
          window.dispatchEvent(new CustomEvent('bcwfc:orphan-personalisation-removed', {
            detail: { keys: secondOrphans.map(function (item) { return item.key; }) }
          }));
        });
      });
    });
  }

  function runCartOrphanCheck() {
    if (state.cartCheckRunning || state.cartRefreshRunning) return;
    state.cartCheckRunning = true;

    getCart().then(function (cart) {
      var orphans = findOrphanPersonalisationItems(cart);
      if (!orphans.length) return null;
      return confirmAndRemoveOrphans(orphans);
    }).catch(function () {
      /* Fail silently so normal cart behaviour is never blocked. */
    }).finally(function () {
      state.cartCheckRunning = false;
    });
  }

  function scheduleCartOrphanCheck(delay) {
    window.clearTimeout(state.cartCheckTimer);
    state.cartCheckTimer = window.setTimeout(
      runCartOrphanCheck,
      delay == null ? CONFIG.cartCheckDelay : delay
    );
  }

  function observeCart() {
    var cartNode = document.querySelector('cart-drawer') || document.querySelector('cart-page');
    if (!cartNode || cartNode === state.cartObservedNode) return;

    if (state.cartObserver) state.cartObserver.disconnect();

    state.cartObservedNode = cartNode;
    state.cartObserver = new MutationObserver(function () {
      if (state.cartCheckRunning || state.cartRefreshRunning) return;

      var now = Date.now();
      if (now - state.lastCartMutationAt < 250) return;
      state.lastCartMutationAt = now;

      scheduleCartOrphanCheck(1600);
    });

    state.cartObserver.observe(cartNode, { childList: true, subtree: true });
  }

  function shouldCheckInitialCart() {
    if (/\/cart\/?$/.test(window.location.pathname)) return true;

    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.hasAttribute('empty-cart')) return false;
    return Boolean(drawer.querySelector('cart-item'));
  }

  function initialiseCartProtection() {
    observeCart();
    if (shouldCheckInitialCart()) scheduleCartOrphanCheck(1000);

    window.addEventListener('pplrAddToCartCompleted', function () {
      scheduleCartOrphanCheck(1800);
    });

    document.addEventListener('click', function (event) {
      var cartAction = event.target && event.target.closest && event.target.closest(
        'cart-remove-button, [data-cart-remove], [data-cart-item-remove], cart-quantity-button, quantity-btn'
      );

      if (cartAction) scheduleCartOrphanCheck(1100);
    }, true);

    document.addEventListener('change', function (event) {
      var cartInput = event.target && event.target.closest && event.target.closest(
        'cart-drawer input, cart-page input, cart-drawer select, cart-page select'
      );

      if (cartInput) scheduleCartOrphanCheck(1100);
    }, true);

    document.addEventListener('shopify:section:load', function () {
      observeCart();
      scheduleCartOrphanCheck(1000);
    });

    window.addEventListener('pageshow', function () {
      observeCart();
      if (shouldCheckInitialCart()) scheduleCartOrphanCheck(800);
    });
  }

  function initialise() {
    if (PAGE.isProduct && isRelevantJerseyPage()) {
      state.lastSizeValue = getCurrentSizeValue();
      document.addEventListener('change', handleSizeChange, true);
      startPlayerWatcher();

      window.addEventListener('pplrAppInitiated', startPlayerWatcher);

      if (window.__bcwfcPplrEventState && window.__bcwfcPplrEventState.initiated) {
        startPlayerWatcher();
      }
    }

    initialiseCartProtection();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();
/* Modified by LB 2026-08-11 - Jersey player URL, no-reload size sync and orphan personalisation protection - end */